// React Router asks history to confirm a blocked transition through the Router's
// getUserConfirmation. A screen with its own confirmation dialog registers a
// handler here and makes its <Prompt> return NAVIGATION_CONFIRMATION_MESSAGE;
// history then completes or reverts the transition itself, so browser Back and
// Forward keep the history stack intact. Any other prompt message still goes to
// window.confirm, like history's default.

export const NAVIGATION_CONFIRMATION_MESSAGE = 'c1do1:navigation-confirmation';

let activeHandler = null;

export const registerNavigationConfirmation = (handler) => {
  activeHandler = handler;
  return () => {
    if (activeHandler === handler) activeHandler = null;
  };
};

export const getUserConfirmation = (message, callback) => {
  if (message === NAVIGATION_CONFIRMATION_MESSAGE && activeHandler) {
    activeHandler(callback);
    return;
  }
  callback(window.confirm(message)); // eslint-disable-line no-alert
};
